export default __webpack_public_path__ + "ai-enabled.3b1c52ce.png";